import styled from "styled-components/macro";
import { colors } from "theme/Theme";
import { toRem, device } from "theme/Breakpoints";
import { shadow } from "theme/GlobalElements";

import { defaultHorizontalMargin, DefaultText, panelBackground } from "theme/GlobalElements";

export const PaymentPageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  ${defaultHorizontalMargin};
  margin-top: 30px;
  @media only screen and (${device.tablet}) {
    margin-top: 20px;
  }
`;
export const TitleContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  & svg {
    margin: 0 10px;
  }
`;
export const Title = styled(DefaultText)`
  margin: 30px 0;
  align-self: center;
`;

export const SubTitle = styled(Title)`
  margin: 0;
  padding-bottom: 20px;
  text-align: center;
  color: ${colors.lighter_blue};
  font-weight: 700;
`;
export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  @media only screen and (${device.laptop}) {
    flex-direction: row;
  }
`;
export const PersonalInfo = styled.div`
  ${shadow}
  background-color: ${colors.gray};
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 30px 15px;
  box-sizing: border-box;
  height: auto;
  /* @media only screen and (${device.tablet}) {
    margin-right: 5px;
  } */
  @media only screen and (${device.laptop}) {
    max-width: ${toRem(400)};
  }
`;
export const InputContainer = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;
export const InputWrapper = styled.div`
  display: inline-flex;
  justify-content: space-evenly;
`;
export const Label = styled(DefaultText)`
  align-self: center;
  width: 100%;
`;

export const Input = styled.input`
  font-size: 16px;
  background-color: white;
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid #bababa;
  padding: 0 10px;
  width: 100%;
  height: ${toRem(30)};
`;

export const ErrorMessage = styled.p`
  padding-top: 5px;
  color: red;
`;
export const CheckBoxContainer = styled.div`
  margin-top: 10px;
  display: inline-flex;
  max-width: 100%;
  text-align: right;

  & span {
    float: left;
    margin-left: 5px;
    width: 85%;
    text-align: left;
    line-height: 1.2;
    a {
      color: ${colors.lighter_blue};
    }
  }
  &.required:after {
    content: "* ";
    color: #f00;
    font-weight: bold;
  }
`;
export const CheckBox = styled.input`
  height: ${toRem(25)};
  width: ${toRem(25)};
  float: left;
  border-radius: 5px;
  background-color: white;
  box-sizing: border-box;
  border: 1px solid #bababa;
`;

export const PaymentInfo = styled.div`
  ${shadow}
  background-color: ${colors.gray};
  padding: 30px 15px;
  box-sizing: border-box;
  height: auto;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  /* @media only screen and (${device.tablet}) {
    margin-left: 5px;
  } */
  @media only screen and (${device.laptop}) {
    flex: 2;
    margin-left: 20px;
  }
`;
export const TopSection = styled.div`
  flex: 1;
`;
export const AdditionalInfoContainer = styled.div``;

export const TextArea = styled.textarea`
  margin-top: 10px;
  box-sizing: border-box;
  height: ${toRem(100)};
  width: 100%;
  padding: 10px;
  resize: vertical;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #bababa;
`;
export const TypeOfPaymentContainer = styled.div`
  margin: 20px 0;
`;
export const Payments = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row wrap;
`;
export const Payment = styled.div`
  padding-right: 10px;
  &span {
    margin-left: 5px;

    text-align: left;
  }
`;

export const PaymentCheckBox = styled.input``;
export const BankTransfeInfo = styled.div`
  margin-top: 10px;
  box-sizing: border-box;
  padding: 10px;

  border-radius: 5px;
  border-width: 0;
  -webkit-box-shadow: inset 0px 0px 36px -20px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: inset 0px 0px 36px -20px rgba(0, 0, 0, 0.5);
  box-shadow: inset 0px 0px 36px -20px rgba(0, 0, 0, 0.5);
`;

export const ButtonWrapper = styled.div`
  padding: 20px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const SubmitButton = styled.input`
  border-radius: 5px;
  color: white;
  background-color: ${colors.lighter_blue};
  border-width: 0;
  height: 40px;
  box-sizing: border-box;
  padding: 0 20px;
  font-weight: 600;
  width: auto;
  cursor: pointer;
  &:hover {
    background-color: ${colors.light_blue};
  }
`;
